var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBancoDelSol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -26.39,
    cy: 64.45,
    fx: -26.39,
    fy: 64.45,
    r: 5.51,
    gradientTransform: "translate(33.49 74.2) rotate(1.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#dc4868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#de5760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#e17152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#e28149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e38646"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81,8.88c-.94-.89-1.18-2.3-.6-3.46l.07-.15-.9-.44-.07.15c-.78,1.55-.46,3.43.8,4.62l.12.12.7-.72-.12-.12ZM11.19,9.12c.94.89,1.18,2.3.6,3.46l-.07.14.9.44.07-.15c.78-1.55.46-3.43-.8-4.62l-.12-.11-.7.72.11.13ZM7.37,10.47c-1.3.03-2.46-.79-2.87-2.02l-.05-.16-.94.32.05.16c.54,1.65,2.1,2.74,3.83,2.7h.17l-.02-1h-.17ZM10.64,7.53c1.3-.03,2.46.79,2.87,2.02l.05.16.95-.32-.05-.16c-.54-1.65-2.1-2.74-3.83-2.7h-.17v1s.18,0,.18,0ZM8.89,11.19c-.89.94-2.3,1.19-3.46.6l-.15-.07-.44.9.15.07c1.55.78,3.43.46,4.62-.8l.11-.12-.72-.7-.12.12ZM9.13,6.81c.89-.94,2.3-1.18,3.46-.6l.15.07.44-.9-.15-.07c-1.55-.78-3.43-.46-4.62.8l-.12.12.72.7.13-.12ZM10.48,10.63c.03,1.3-.79,2.46-2.02,2.87l-.16.05.32.95.16-.05c1.65-.54,2.74-2.1,2.7-3.83v-.17h-1v.18ZM7.54,7.37c-.03-1.3.79-2.46,2.02-2.87l.16-.05-.32-.95-.16.05c-1.65.54-2.74,2.1-2.7,3.83v.17h1s0-.18,0-.18Z",
    style: {
      fill: "url(#radial-gradient)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancoDelSol);
export default __webpack_public_path__ + "static/media/banco-del-sol.de83cc17a55977b77830e359e68206f7.svg";
export { ForwardRef as ReactComponent };